import React from 'react';

export const Play = ({ }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 12.866C20.1667 12.4811 20.1667 11.5189 19.5 11.134L7.5 4.20577C6.83333 3.82087 6 4.30199 6 5.07179L6 18.9282C6 19.698 6.83333 20.1791 7.5 19.7942L19.5 12.866Z" fill="white" className={`icon-fill icon-fill-secondary icon-fill-active-accent`} />
        </svg>
    )
};
